import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import StartQuiz from '@/components/StartQuiz.vue'
import ThankPage from '@/components/ThankPage'
import LoginPage from '@/components/LoginPage'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    privateKey: '',
    timer: false,
    buttonDisabled: false,
    session_id: null,
  }
})

const router = new VueRouter({
    routes: [
      { path: '/startQuiz', 
        component: StartQuiz, 
        beforeEnter: (to, from, next) => {
        if(store.state.privateKey === '') {
            next({path: "/"})
          } else {
            next();
          }
        } 
      }, // No props, no nothing
      { path: '/thankPage',
        component: ThankPage,
        beforeEnter: (to, from, next) => {
        if(store.state.privateKey === '') {
            next({path: "/"})
          } else {
            next();
          }
        } 
      },
      { path: '/', component: LoginPage}
    ]
  })



const app = new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')